import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { WISH_LISTS_BY_USER_ID } from '../../graphql/queries/wishlistQueries';

export const useFetchWishlists = (userID) => {
  const { data, loading, error } = useQuery(WISH_LISTS_BY_USER_ID, {
    variables: { userID },
    skip: !userID,
    fetchPolicy: 'cache-and-network',
  });

  const processedWishlists = useMemo(() => {
    if (!data?.wishListsByUserID) return null;
    
    const wishlists = { ...data.wishListsByUserID };
    if (wishlists.items && Array.isArray(wishlists.items)) {
      wishlists.items = wishlists.items.map(wishlist => {
        if (!wishlist) return wishlist;

        return {
          ...wishlist,
          User: {
            ...wishlist.User,
          }
        };
      });
    }

    return wishlists;
  }, [data]);

  return {
    wishlistsData: processedWishlists,
    loading,
    error
  };
};